import { useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import AppearanceContent from '../components/AppearanceContent';
import type { SettingsOutletContext } from '../index';

export const titleReturner = (title: string): string | undefined => {
  switch (title) {
    case 'vertical':
      return 'عمودی';

    case 'top':
      return 'بالا';

    case 'combo':
      return 'هردو';

    case 'double-top':
      return 'بالا دوخطی';

    default:
      break;
  }
};

const Appearance = () => {
  const isSmUp = useMediaQuery(breakpointsMediaQuery.sm);

  const [, setBreadcrumbData] = useOutletContext<SettingsOutletContext>();
  useEffect(() => {
    setBreadcrumbData([{ text: 'تنظیمات ظاهری', href: '#' }]);
  }, [setBreadcrumbData]);

  return isSmUp ? (
    <Card>
      <Card.Body>
        <AppearanceContent />
      </Card.Body>
    </Card>
  ) : (
    <AppearanceContent />
  );
};

export default Appearance;
